/**
 * File: navigation-primary.js
 *
 * Help deal with the main nav
 */

import {gsap} from 'gsap';

// Make sure everything is loaded first.
if ( ( 'complete' === document.readyState || 'loading' !== document.readyState ) && ! document.documentElement.doScroll ) {
	ngenMainNavigation();
} else {
	document.addEventListener( 'DOMContentLoaded', ngenMainNavigation );
}

/**
 * Kick off our menu functions.
 */
function ngenMainNavigation() {
	const hamburger = document.getElementById('hamburger');
	const navigation = document.getElementById('site-navigation');
	const header = document.getElementById('SiteHeader');

	hamburger.addEventListener( 'click', toggleMenu );
	document.body.addEventListener( 'keydown', closeOnEscape );

	const metaBallTl = gsap.timeline({
		paused: true,
		onComplete: () => {
			navigation.classList.add('is-visible');
			header.classList.add('is-active');
			hamburger.setAttribute( 'aria-expanded', 'true' );
		}
	});

	/**
	 * Close everything when we hit the escape key.
	 *
	 * @param {Object} event The event trigger.
	 */
	function closeOnEscape( event ) {
		if ( 27 === event.keyCode ) {
			closeMenu();
		}
	}

	/**
	 * Handle closing the menu.
	 */
	function closeMenu() {
		hamburger.classList.remove( 'is-active' );
		navigation.classList.remove('is-visible');
		header.classList.remove('is-active');

		hamburger.setAttribute( 'aria-expanded', 'false' );
		metaBallTl.reverse();
	}

	/**
	 * Toggle the display of the menu.
	 */
	function toggleMenu() {
		if ( 'true' === hamburger.getAttribute( 'aria-expanded' ) ) {
			closeMenu();
		} else {
			openMenu();
		}
	}

	/**
	 * Handle opening the menu.
	 */
	function openMenu() {
		hamburger.classList.add( 'is-active' );
		metaBallTl.play();
	}

	// generate metaballs at random positions and sizes
	// scale to fill screen
	// on close scale to 0 then remove

	function generateMetaballs(numBalls) {

		const groupContainer = document.getElementById('MetaBallGroup');

		for(let i = 0; i <= numBalls; i++) {

			const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
			const cx = gsap.utils.random(0, 100);
			const cy = gsap.utils.random(0, 250);
			const r = '0';

			circle.setAttribute('cx', cx);
			circle.setAttribute('cy', cy);
			circle.setAttribute('r', r);

			groupContainer.appendChild(circle);

			metaBallTl.to(circle, {
				attr: {
					r: 70
				},
				duration: 0.8,
				ease: 'power4.in'
			}, 0);

		}

	}

	generateMetaballs(50);

}
